import React from 'react'
// import SectionMainBanner from '../../molecules/section-main-banner/section-main-banner';
// import SectionTheNew from '../../molecules/section-the-new/section-the-new';
// import SectionVideosContent from '../../molecules/section-videos-content/section-videos-content';
// import SectionFemaleCare from '../../molecules/section-female-care/section-female-care';
// import SectionConsulting from '../../molecules/section-consulting/section-consulting';
// import SectionNosotrasNews from '../../molecules/section-nosotras-news/section-nosotras-news';

import './prediction-sign.scss'
import HeaderHoroscope from '../../molecules/header-horoscope/header-horoscope'
import Prediction from '../../molecules/prediction/prediction'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb'
// import SectionProductsOutstanding from '../../molecules/section-products-outstanding/section-products-outstanding';
// import SectionCompetition from '../../molecules/section- competition/section-competition';

const PredictionSign = props => {
    const { setModalActive } = props

    const [pageChange, setPageChange] = React.useState(false);
    // var news_info=props.dataProp
    return (
        <div className="f-prediction">
            <div className="f-breadcrum-position">
                <Breadcrumb mobile={props.mobile} />
            </div>
            <HeaderHoroscope sign={props.sign.titulo} setPageChange={setPageChange} />
            <Prediction prediction={props.sign} pageChange={pageChange} mobile={props.mobile} setModalActive={setModalActive} />
        </div>
    )
}
export default PredictionSign;
